<script setup lang="ts">
    import AppMenuAccountTB from '@/components/menu/AppMenuAccountTB.vue';
    import AppMenuDarkSwitcher from '@/components/menu/AppMenuDarkSwitcher.vue';
    import AppMenuHelp from '@/components/menu/AppMenuHelp.vue';
    import AppMenuNotification from '@/components/menu/AppMenuNotification.vue';
    import AppSearch from './../../pages/core/search/AppSearch.vue';
    import AppMenuUserBalanceInfo from '@/components/menu/AppMenuUserBalanceInfo.vue';
    import { useUserStore } from '@/stores/user';
    import { useMenuStore } from '@/stores/menu';
    import AppMenuNav from '@/components/menu/AppMenuNav.vue';
    import { useDisplay, useTheme } from 'vuetify';

    const userStore = useUserStore();
    const menuStore = useMenuStore();
    const display = useDisplay();
    const theme = useTheme();

    const navMenuItems = computed(() => menuStore.getNavMenuItems);

    const isDesktopMenu = computed<boolean>(() => {
        let width = 1425;
        if (!userStore.settings.is_show_exposure) width -= 130;
        if (!userStore.settings.is_show_balance) width -= 130;
        if (!userStore.settings.is_show_credit) width -= 115;

        return display.width.value > width;
    });

    watch(isDesktopMenu, (value: boolean) => {
        if (value && menuStore.mobileMenuDrawer) {
            menuStore.mobileMenuDrawer = false;
        }
    });
</script>
<template>
    <v-card class="overflow-hidden">
        <v-app-bar id="menu" app dense flat tile elevation="0" color="#fff" class="menu-border" height="47">
            <v-toolbar-title :class="[display.width.value > 1263 ? 'pr-4' : '']" class="hidden-sm-and-down ml-4" style="width: 170px; max-width: 170px">
                <router-link v-if="userStore.isLoggedIn()" :to="{ name: 'favourite' }" class="link-plain">
                    <img class="main-logo" width="" alt="logo" src="/images/main/TB_Logo_Green.svg" />
                </router-link>
                <img v-else class="main-logo" width="" alt="logo" src="/images/main/TB_Logo_Green.svg" />
            </v-toolbar-title>

            <AppMenuNav v-if="isDesktopMenu" :items="navMenuItems"></AppMenuNav>

            <v-app-bar-nav-icon v-else class="ml-2 ml-md-0" @click="menuStore.mobileMenuDrawer = true">
                <v-icon :color="theme.name.value === 'dark' ? '#b5bac1' : 'tbGreen'" style="background: transparent !important" :icon="mdiMenu" />
            </v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <AppSearch></AppSearch>

            <AppMenuUserBalanceInfo v-if="display.width.value > 680"></AppMenuUserBalanceInfo>

            <AppMenuDarkSwitcher></AppMenuDarkSwitcher>

            <AppMenuAccountTB></AppMenuAccountTB>

            <AppMenuNotification></AppMenuNotification>

            <AppMenuHelp :items="menuStore.navMenuSupportItems"></AppMenuHelp>
        </v-app-bar>
    </v-card>
</template>
<style scoped>
    .v-theme--light .menu-border {
        border-bottom: 1px solid #e0e0e0 !important;
    }

    .v-theme--dark .menu-border {
        border-bottom: 1px solid #404148 !important;
    }

    .v-theme--dark {
        background-color: #1e1f22 !important;
    }
</style>
